import { styled } from "@mui/material";

export const StyledSup = styled("sup")<{ marginRight: number }>(({ marginRight }) => ({
    marginRight: marginRight,
}));

export const StyledLink = styled("a")(({ theme }) => ({
    textDecoration: "none",
    color: theme.palette.blue._50,
}));
